import { ENV } from '../config/environment';

export const updatePageTitle = (pageTitle?: string): void => {
  const baseTitle = ENV.APP_NAME;
  document.title = pageTitle ? `${pageTitle} | ${baseTitle}` : baseTitle;
};